import { render, staticRenderFns } from "./InsurerListView.vue?vue&type=template&id=282fb7ca&scoped=true"
import script from "./InsurerListView.vue?vue&type=script&lang=js"
export * from "./InsurerListView.vue?vue&type=script&lang=js"
import style0 from "./InsurerListView.vue?vue&type=style&index=0&id=282fb7ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "282fb7ca",
  null
  
)

export default component.exports